import { render, staticRenderFns } from "./CowsTab.vue?vue&type=template&id=1d58ef4e&"
import script from "./CowsTab.vue?vue&type=script&lang=js&"
export * from "./CowsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports